module.exports = __webpack_public_path__ + "static/img/xiaohe.3cb8225.png";


//////////////////
// WEBPACK FOOTER
// ./static/xiaohe.png
// module id = chr4
// module chunks = 1